import { TableCell as Mui4TableCell, TableCellProps as Mui4TableCellProps } from '@material-ui/core'
import { default as Mui5TableCell, TableCellProps as Mui5TableCellPropsType } from '@mui/material/TableCell'
import { forwardRef } from 'react'
import { useComponentVersion } from '../hooks'
import { OsTableVersion } from './Table'

export type TableCellProps = Mui4TableCellProps
/** @deprecated Use TableCellProps */
export type OsTableCellProps = TableCellProps

export const TableCell = forwardRef<HTMLTableCellElement, TableCellProps>((props, ref) => {
  const version = useComponentVersion('table')
  switch (version) {
    case OsTableVersion.V2: {
      const { padding, ...rest } = props
      let padding5: Mui5TableCellPropsType['padding'] = padding === 'default' ? 'normal' : padding
      return <Mui5TableCell ref={ref} padding={padding5} {...rest} />
    }

    default:
      return <Mui4TableCell ref={ref} {...props} />
  }
})
